import React from 'react';
import { SkeletonTable } from './SkeletonTable';

export const ExportTable = ({ exportStatus }) => {
	if (exportStatus.loading) {
		return (
			<SkeletonTable
				numRows={5}
				cols={['Property', 'Count', 'Date']}
				height={'400px'}
			/>
		);
	} else if (exportStatus.data) {
		return (
			<>
				<h5 className="mt-5 mb-3">Steel Export Status</h5>

				<div className="table-responsive">
					<table className="captureTable">
						<thead>
							<tr>
								<th>Property</th>
								<th>Count</th>
								<th>Date</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Capacity</td>
								<td>{exportStatus?.data['steel/capacity']?.filesCount}</td>
								<td>{exportStatus?.data['steel/capacity']?.minUpdateDate}</td>
							</tr>

							<tr>
								<td>Index</td>
								<td>{exportStatus?.data['steel/index']?.filesCount}</td>
								<td>{exportStatus?.data['steel/index']?.minUpdateDate}</td>
							</tr>

							<tr>
								<td>Production</td>
								<td>{exportStatus?.data['steel/production']?.filesCount}</td>
								<td>{exportStatus?.data['steel/production']?.minUpdateDate}</td>
							</tr>

							<tr>
								<td>Production C02</td>
								<td>
									{exportStatus?.data['steel/production/co2']?.filesCount}
								</td>
								<td>
									{exportStatus?.data['steel/production/co2']?.minUpdateDate}
								</td>
							</tr>

							<tr>
								<td>Smelter Data</td>
								<td>{exportStatus?.data['steel/smelter_data']?.filesCount}</td>
								<td>
									{exportStatus?.data['steel/smelter_data']?.minUpdateDate}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</>
		);
	} else {
		<></>;
	}
};
